var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9881 13.0322C24.9881 11.984 24.903 11.219 24.7189 10.4258H12.749V15.157H19.7751C19.6335 16.3328 18.8686 18.1035 17.1687 19.2934L17.1448 19.4518L20.9295 22.3837L21.1917 22.4099C23.5998 20.1858 24.9881 16.9136 24.9881 13.0322Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.749 25.498C16.1912 25.498 19.081 24.3647 21.1917 22.41L17.1687 19.2935C16.0921 20.0442 14.6472 20.5684 12.749 20.5684C9.37764 20.5684 6.51621 18.3444 5.49619 15.2705L5.34668 15.2832L1.41133 18.3288L1.35986 18.4719C3.45635 22.6365 7.7627 25.498 12.749 25.498Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49619 15.2703C5.22705 14.4771 5.07129 13.6271 5.07129 12.7488C5.07129 11.8705 5.22705 11.0206 5.48203 10.2273L5.4749 10.0584L1.49023 6.96387L1.35986 7.02588C0.495801 8.7541 0 10.6948 0 12.7488C0 14.8028 0.495801 16.7435 1.35986 18.4717L5.49619 15.2703Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.749 4.92959C15.143 4.92959 16.7578 5.96367 17.6786 6.82783L21.2767 3.31475C19.0669 1.26074 16.1912 0 12.749 0C7.76269 0 3.45635 2.86143 1.35986 7.02607L5.48203 10.2275C6.51621 7.15361 9.37764 4.92959 12.749 4.92959Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGIcon);
export default __webpack_public_path__ + "static/media/g-icon.992473a6f906a634b82c1ecd17606f97.svg";
export { ForwardRef as ReactComponent };